import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, Button } from "react-bootstrap";
import { FiMail, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import NavBar from "../Components/NavBar";
import Loaders from "../Components/FullScreenLoader";
import Api from "../Service/Api";
import { connect } from "react-redux";
import { getProfile } from "../Redux/actions/common";

const Verification = (props) => {
  const history = useHistory();
  const [user, setUser] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const auth = localStorage.getItem("Auth");
    const token = localStorage.getItem("accesstoken");

    if (auth !== "true" || !token) {
      history.replace("/login");
      return;
    }

    Api.get(`/users/my-profile`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        props.getProfile(res.data);
        setUser(res.data);
        setPageLoading(false);
      })
      .catch(() => {
        setError("Could not load your account. Please try again.");
        setPageLoading(false);
      });
  }, [history]);

  const resendVerificationEmail = () => {
    const token = localStorage.getItem("accesstoken");
    if (!token) {
      history.replace("/login");
      return;
    }

    setSending(true);
    setMessage("");
    setError("");

    Api.get(`auth/resendverificationemail`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        setMessage(
          "Verification email sent. Please check your inbox and spam folder."
        );
        setSending(false);
      })
      .catch((err) => {
        const errMsg = err?.response?.data?.message;
        if (errMsg && String(errMsg).toLowerCase().includes("verified")) {
          setMessage("Your email is already verified. You can continue browsing.");
          Api.get(`/users/my-profile`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }).then((res) => {
            props.getProfile(res.data);
            setUser(res.data);
          });
        } else {
          setError("Could not send the email. Please try again in a moment.");
        }
        setSending(false);
      });
  };

  const isVerified = user?.emailVerified === true;

  return (
    <div className="auth-layout">
      <NavBar />
      {(pageLoading || sending) && <Loaders />}

      <section className="login-page login-page--verification">
        <div className="login-page__backdrop" aria-hidden="true" />

        <div className="container login-page__container">
          <Row className="justify-content-center">
            <Col xs={12} sm={11} md={10} lg={9} xl={8}>
              <Card className="login-page__card">
                <Row className="g-0">
                  <Col
                    md={5}
                    className="login-page__panel login-page__panel--brand d-none d-md-flex"
                  >
                    <div className="login-page__brand-content">
                    
                      <h2 className="login-page__brand-title">
                        One step away
                      </h2>
                      <p className="login-page__brand-text">
                        Verifying your email keeps your account secure and lets
                        you book treks, manage trips, and receive booking
                        updates.
                      </p>
                    </div>
                  </Col>

                  <Col
                    md={7}
                    className="login-page__panel login-page__panel--form"
                  >
                    <div className="login-page__form-wrap verification-page__content">
                      <div className="login-page__mobile-brand d-md-none">
                         
                      </div>

                      {!pageLoading && user && (
                        <>
                          <div className="verification-page__icon-wrap">
                            {isVerified ? (
                              <FiCheckCircle
                                className="verification-page__icon verification-page__icon--success"
                                aria-hidden="true"
                              />
                            ) : (
                              <FiMail
                                className="verification-page__icon verification-page__icon--pending"
                                aria-hidden="true"
                              />
                            )}
                          </div>

                          <h1 className="login-page__title">
                            {isVerified
                              ? "Email verified"
                              : "Verify your email"}
                          </h1>

                          <p className="login-page__subtitle">
                            {user.name ? `Hi ${user.name}, ` : ""}
                            {isVerified
                              ? "your account is active. You're all set to explore."
                              : "we sent a verification link to your inbox."}
                          </p>

                          <div
                            className={`verification-page__status ${
                              isVerified
                                ? "verification-page__status--success"
                                : "verification-page__status--pending"
                            }`}
                          >
                            {!isVerified && (
                              <>
                                <FiAlertCircle
                                  className="verification-page__status-icon"
                                  aria-hidden="true"
                                />
                                <div>
                                  <p className="verification-page__status-title">
                                    Check your email
                                  </p>
                                  <p className="verification-page__email">
                                    {user.email}
                                  </p>
                                  <p className="verification-page__status-text">
                                    Open the link in that message to activate
                                    your account. If you don&apos;t see it,
                                    check spam or resend below.
                                  </p>
                                </div>
                              </>
                            )}

                            {isVerified && (
                              <>
                                <FiCheckCircle
                                  className="verification-page__status-icon verification-page__status-icon--success"
                                  aria-hidden="true"
                                />
                                <div>
                                  <p className="verification-page__status-title">
                                    You&apos;re verified
                                  </p>
                                  <p className="verification-page__status-text">
                                    Thanks for confirming{" "}
                                    <strong>{user.email}</strong>. You can now
                                    book adventures on BookMyTrek.
                                  </p>
                                </div>
                              </>
                            )}
                          </div>

                          {message && (
                            <div
                              className="login-page__alert login-page__alert--success"
                              role="status"
                            >
                              {message}
                            </div>
                          )}

                          {error && (
                            <div className="login-page__alert" role="alert">
                              {error}
                            </div>
                          )}

                          <div className="verification-page__actions">
                            {!isVerified && (
                              <Button
                                type="button"
                                className="login-page__submit"
                                onClick={resendVerificationEmail}
                                disabled={sending}
                              >
                                Resend verification email
                              </Button>
                            )}

                            {isVerified && (
                              <Link
                                to="/"
                                className="login-page__submit verification-page__cta-link"
                              >
                                Continue to homepage
                              </Link>
                            )}

                            {!isVerified && (
                              <p className="login-page__signup verification-page__footer-note">
                                Wrong account?{" "}
                                <Link
                                  to="/login"
                                  className="login-page__link login-page__link--bold"
                                >
                                  Sign in again
                                </Link>
                              </p>
                            )}
                          </div>
                        </>
                      )}

                      {!pageLoading && !user && error && (
                        <div className="verification-page__content">
                          <div className="login-page__alert" role="alert">
                            {error}
                          </div>
                          <Link
                            to="/login"
                            className="login-page__link login-page__link--bold"
                          >
                            Back to sign in
                          </Link>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getProfile: (data) => dispatch(getProfile(data)),
});

export default connect(null, mapDispatchToProps)(Verification);
